import { Injectable } from '@angular/core';
import {environment} from "../../environments/environment";
import {HttpClient} from "../../../node_modules/@angular/common/http";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {Plano} from "../models/plano";

@Injectable({
  providedIn: 'root'
})
export class ExecucaoPlanoService {

	private api_url = environment.api_url + "/execucao-plano";

	constructor(private http: HttpClient) {

	}

	save(form: Plano, cod_configuracao_grupo_plano: string): Observable<any> {
		let url: string = this.api_url;
		let http;
		if(form.cod_plano){
			http = this.http.put(url + "/" + form.cod_plano + "/" + cod_configuracao_grupo_plano, form);
		}else{
			http = this.http.post(url, form);
		}
		return http.pipe(map((res: any) => {
			return res.data;
		}));
	}

	revisarMinuta(cod_plano: number): Observable<any> {
		let url: string = this.api_url + "/revisar_minuta/" + cod_plano;
		return this.http.get(url).pipe(map((res: any) => {
			return res;
		}));
	}

}
